"use strict";

var Language = /* @__PURE__ */(Language2 => {
  Language2["En"] = "en";
  Language2["Ar"] = "ar";
  Language2["De"] = "de";
  Language2["El"] = "el";
  Language2["Fr"] = "fr";
  Language2["It"] = "it";
  Language2["Ja"] = "ja";
  Language2["Zh"] = "zh";
  Language2["Tw"] = "zh-tw";
  Language2["Ca"] = "ca";
  Language2["Cs"] = "cs";
  Language2["Da"] = "da";
  Language2["Nl"] = "nl";
  Language2["Ko"] = "ko";
  Language2["No"] = "no";
  Language2["Pl"] = "pl";
  Language2["PtBr"] = "pt-br";
  Language2["PtPt"] = "pt-pt";
  Language2["Ru"] = "ru";
  Language2["EsMx"] = "es-mx";
  Language2["EsEs"] = "es-es";
  Language2["Sv"] = "sv";
  Language2["Tr"] = "tr";
  return Language2;
})(Language || {});
const LanguageToSmartcatLocaleMapping = {
  ["ar" /* Ar */]: "ar",
  ["de" /* De */]: "de",
  ["en" /* En */]: "en",
  ["fr" /* Fr */]: "fr",
  ["el" /* El */]: "el",
  ["it" /* It */]: "it",
  ["ja" /* Ja */]: "ja",
  ["zh" /* Zh */]: "zh-Hans",
  ["zh-tw" /* Tw */]: "zh-Hant-TW",
  ["ca" /* Ca */]: "ca",
  ["cs" /* Cs */]: "cs",
  ["da" /* Da */]: "da",
  ["nl" /* Nl */]: "nl",
  ["ko" /* Ko */]: "ko",
  ["no" /* No */]: "no",
  ["pl" /* Pl */]: "pl",
  ["pt-br" /* PtBr */]: "pt-BR",
  ["pt-pt" /* PtPt */]: "pt-PT",
  ["ru" /* Ru */]: "ru",
  ["es-mx" /* EsMx */]: "es-MX",
  ["es-es" /* EsEs */]: "es-ES",
  ["sv" /* Sv */]: "sv",
  ["tr" /* Tr */]: "tr"
};
var AddressUsageType = /* @__PURE__ */(AddressUsageType2 => {
  AddressUsageType2[AddressUsageType2["Billing"] = 0] = "Billing";
  AddressUsageType2[AddressUsageType2["Shipping"] = 1] = "Shipping";
  AddressUsageType2[AddressUsageType2["ReturnShipping"] = 2] = "ReturnShipping";
  return AddressUsageType2;
})(AddressUsageType || {});
export { AddressUsageType, Language, LanguageToSmartcatLocaleMapping };
//# sourceMappingURL=constants.mjs.map
